export default "__VITE_ASSET__DnZK9eVS__"